import { render, staticRenderFns } from "./iconFont.vue?vue&type=template&id=87cd33c2"
import script from "./iconFont.vue?vue&type=script&lang=js"
export * from "./iconFont.vue?vue&type=script&lang=js"
import style0 from "./iconFont.vue?vue&type=style&index=0&id=87cd33c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports